/**
 * The registration manifest — every `defineElement` call AND the
 * HTMLElementTagNameMap augmentation, in ONE file (guide Step 4). Tag names are
 * app-prefixed kebab-case domain nouns.
 */

import { defineBrandMark, defineElement, defineOutlet, type KitBrandMark } from "@platform/web-kit"
import { CareerApp } from "./surfaces/career-app"
import { CareerLogin } from "./surfaces/career-login"
import { CareerNotFound } from "./surfaces/career-not-found"
import { CareerHeartbeat } from "./surfaces/career-heartbeat"
import { CareerOpportunityDetail } from "./surfaces/career-opportunity-detail"
import { CareerLlmSettings } from "./surfaces/career-llm-settings"
import { CareerOnboarding } from "./surfaces/career-onboarding"
import { CareerExtractionReview } from "./surfaces/career-extraction-review"
import { CareerCompassHub } from "./surfaces/career-compass-hub"
import { CareerProfile } from "./surfaces/career-profile"
import { CareerCvWorkbench } from "./surfaces/career-cv-workbench"
import { CareerEvidenceLedger } from "./surfaces/career-evidence-ledger"
import { CareerAssets } from "./surfaces/career-assets"
import { CareerCvPrint } from "./surfaces/career-cv-print"
import { CareerWorkshopList } from "./surfaces/career-workshop-list"
import { CareerWorkshopRunner } from "./surfaces/career-workshop-runner"
import { CareerSearch } from "./surfaces/career-search"
import { CareerApplications } from "./surfaces/career-applications"
import { CareerApplicationReview } from "./surfaces/career-application-review"
import { CareerRuns } from "./surfaces/career-runs"
import { CareerCredits } from "./surfaces/career-credits"

export function registerElements(): void {
  defineOutlet() // once, before router.start()
  defineBrandMark() // <kit-brand-mark> (platform P-mark) + its stylesheet — shell + login branding
  defineElement("career-app", CareerApp)
  defineElement("career-login", CareerLogin)
  defineElement("career-not-found", CareerNotFound)
  defineElement("career-heartbeat", CareerHeartbeat)
  defineElement("career-opportunity-detail", CareerOpportunityDetail)
  defineElement("career-onboarding", CareerOnboarding)
  defineElement("career-extraction-review", CareerExtractionReview)
  defineElement("career-compass-hub", CareerCompassHub)
  defineElement("career-profile", CareerProfile)
  defineElement("career-cv-workbench", CareerCvWorkbench)
  defineElement("career-evidence-ledger", CareerEvidenceLedger)
  defineElement("career-assets", CareerAssets)
  defineElement("career-cv-print", CareerCvPrint)
  defineElement("career-workshop-list", CareerWorkshopList)
  defineElement("career-workshop-runner", CareerWorkshopRunner)
  defineElement("career-search", CareerSearch)
  defineElement("career-applications", CareerApplications)
  defineElement("career-application-review", CareerApplicationReview)
  defineElement("career-runs", CareerRuns)
  defineElement("career-credits", CareerCredits)
  defineElement("career-llm-settings", CareerLlmSettings)
}

declare global {
  interface HTMLElementTagNameMap {
    "kit-brand-mark": KitBrandMark
    "career-app": CareerApp
    "career-login": CareerLogin
    "career-not-found": CareerNotFound
    "career-heartbeat": CareerHeartbeat
    "career-opportunity-detail": CareerOpportunityDetail
    "career-onboarding": CareerOnboarding
    "career-extraction-review": CareerExtractionReview
    "career-compass-hub": CareerCompassHub
    "career-profile": CareerProfile
    "career-cv-workbench": CareerCvWorkbench
    "career-evidence-ledger": CareerEvidenceLedger
    "career-assets": CareerAssets
    "career-cv-print": CareerCvPrint
    "career-workshop-list": CareerWorkshopList
    "career-workshop-runner": CareerWorkshopRunner
    "career-search": CareerSearch
    "career-applications": CareerApplications
    "career-application-review": CareerApplicationReview
    "career-runs": CareerRuns
    "career-credits": CareerCredits
    "career-llm-settings": CareerLlmSettings
  }
}
